/* eslint id-length: 0 */
import { htmlAttributes, htmlSelectors } from '../constants';
import { HOMEPAGE_BORDER_RADIUS } from '../constants/constants';

export const isBeaconSent = (element) => {
  let beaconUrl = element.getAttribute(htmlAttributes.ONVIEW_BEACON_NUCLEUS)
    || element.getAttribute(htmlAttributes.DATA_ONVIEW_BEACON_NUCLEUS);
  if (window && window.SponsoredBannerImpressions && window.SponsoredBannerImpressions[beaconUrl]) {
    return true;
  }
  return false;
};

export const getDimensions = (localWindow, element) => {
  let result;

  if (element === localWindow) {
    result = {
      top: 0,
      left: 0,
      bottom: localWindow.innerHeight,
      right: localWindow.innerWidth,
      width: localWindow.innerWidth,
      height: localWindow.innerHeight
    };
  } else if (element.getBoundingClientRect) {
    let {
      bottom,
      height,
      left,
      right,
      top,
      width
    } = element.getBoundingClientRect();

    if (element.id?.includes('hp_sponsored')) {
      bottom -= HOMEPAGE_BORDER_RADIUS;
      right -= HOMEPAGE_BORDER_RADIUS;
      left += HOMEPAGE_BORDER_RADIUS;
      top += HOMEPAGE_BORDER_RADIUS;
      width -= (HOMEPAGE_BORDER_RADIUS * 2);
      height -= (HOMEPAGE_BORDER_RADIUS * 2);
    }

    result = {
      bottom,
      height,
      left,
      right,
      top,
      width
    };
  } else {
    result = {
      bottom: element.offsetTop + element.offsetHeight,
      height: element.offsetHeight,
      left: element.offsetLeft,
      right: element.offsetLeft + element.offsetWidth,
      top: element.offsetTop,
      width: element.offsetWidth
    };
  }

  return result;
};

export const getCoordinates = (dimensions) => {
  const topLeft = {
    x: dimensions.left,
    y: dimensions.top
  };
  const topRight = {
    x: Math.max(dimensions.right - 1, 0),
    y: dimensions.top
  };
  const center = {
    x: dimensions.left + Math.floor((dimensions.right - dimensions.left) / 2),
    y: dimensions.top + Math.floor((dimensions.bottom - dimensions.top) / 2) - 1
  };
  const bottomLeft = {
    x: dimensions.left,
    y: dimensions.bottom - 1
  };
  const bottomRight = {
    x: dimensions.right - 1,
    y: dimensions.bottom - 1
  };

  return [
    topLeft,
    topRight,
    center,
    bottomLeft,
    bottomRight
  ];
};

export const isElementOrChild = (elementAtPoint, matchingElement) => {
  let result = false;

  // If we found it
  if (elementAtPoint === matchingElement) {
    result = true;
    // If there is something else to check
  } else if (elementAtPoint && elementAtPoint.parentElement) {
    result = isElementOrChild(elementAtPoint.parentElement, matchingElement);
  }

  return result;
};

export const getPointsCovered = (localWindow, element) => {
  // Handles things cover the element or it being scrolled out of view
  const elementDimensions = getDimensions(localWindow, element);
  const elementCoordinates = getCoordinates(elementDimensions);
  // At this coordinate, is the banner the top element?
  const elementAtPoints = elementCoordinates.map((coordinate) => {
    return document.elementFromPoint(coordinate.x, coordinate.y);
  });
  const pointsCovered = elementAtPoints.filter((elementAtPoint) => {
    return !isElementOrChild(elementAtPoint, element);
  });
  return pointsCovered.length;
};

export const isTransparent = (element) => {
  let opacityIsZero = (element && element.style && element.style.opacity === '0');

  if (!opacityIsZero && element.parentElement) {
    opacityIsZero = isTransparent(element.parentElement);
  }

  return opacityIsZero;
};

export const isVisible = (localWindow, element) => {
  // checks for display:none anywhere in parent tree
  let result = element.offsetParent !== null;
  if (result) {
    // false if isTransparent
    result = !isTransparent(element);
  }

  if (result) {
    // Each element has 5 points to check visibility (4 corners + center)
    // At least 50% visible if no more than 2 points are covered, i.e. 3 or more points are visible
    let pointsCovered;
    if (element.id === 'hp_sponsored__hero') {
      if (element?.getAttribute(htmlAttributes.DATA_UBC) === 'true') {
        pointsCovered = getPointsCovered(localWindow, element);
      } else { // legacy hero only: check visibility of the wrapper but use attributes from child element
        pointsCovered = getPointsCovered(localWindow, document.querySelector(htmlSelectors.NUCLEUS_HERO_WRAPPER));
      }
    } else {
      pointsCovered = getPointsCovered(localWindow, element);
    }

    result = pointsCovered <= 2;
  }

  return result;
};
